import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import {EMPTY_VALUES, errorMsg, getDateFormat, getFullName, getTimeFormat} from '../../../../../Apis/functions';
import { TABLES } from "../../../../../Apis/Tables";
import {
    CheckIconsOptions, DetailsIconsOptions, EmailOpenPlusOptions, IconClip,
    IconClockTable, IconRejectedByVisitorCard, IconScheduleTable
} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import CustomImageTable from '../../../../../components/CustomImageTable';
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomTh from "../../../../../components/table/CustomTh";
import { SEARCH_MODEL } from "../../../../../components/table/Model/TableModel";
import TableFunction from "../../../../../components/table/TableFunction";
import { statusBorderColor, statusColor, statusFontColor } from "../../../../../enums/statusColorEnum";
import { status, STATUS_MODEL } from "../../../../../enums/statusEnum";
import { VIEW_TYPE } from "../../../../../enums/ViewType";
import { permissionObj } from '../../../../../Helpers/permission';
import SessionData from '../../../../../Helpers/SessionData';
import { DownloadDataZip, ZipDownload } from '../../../../../reduxToolkit/fileUpload/FileUploadApi';
import { ApplyDecisionRequest } from '../../../../../reduxToolkit/RequestAccess/RequestAccessApi';
import { SimpleSearch, SimpleSearchWithId } from "../../../../../reduxToolkit/Search/SearchApi";
import {formatName} from "../Model/Model";
import routes from "../../../../../Routes/routes";
import {VISITOR_SUB_VIEW_MODEL} from "../../Invitation/Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param {string} props.searchElement - Current search string for filtering the table.
 * @param {Array} props.finalArray - Array of records displayed or exported.
 * @param {Function} props.setSearch - Function to trigger a search action.
 * @param {boolean} [props.optionTable=""] - Table name to search
 * @returns {Object} Table utilities, handlers, and state variables to render and control the active requests table.
 */
export const ActiveRequestsTableApp = ({ searchElement, setSearch, optionTable = "", activeStep, modified, setModified}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const isGuardTable = optionTable === TABLES.REQUEST_ACCESS
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [results, setResults] = useState(null); // Store the search results
    const searchId = 'txt__arta_search_active_requests';
    const tableId = 'tbl_arta_active_requests';

    const elementRef = useRef(false);
    const [showModal, setShowModal] = useState(false);
    const [modal, setModal] = useState(null);
    const [detailsModal, setDetailsModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    const endpoint = isGuardTable ? SimpleSearch : SimpleSearchWithId
    const { getUserSession } = SessionData();


    const { id: userId } = getUserSession();

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={0} classes="first_head">{t('visitor')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('phone_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_at')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('documentation')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_status')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item, index) => {
            let requestStatus = item?.statusId;
            const assetsId = item?.assets?.map(asset => asset?.fileUploadDto?.id);
            const visitorFullName = getFullName(item?.requestedByName, item?.requestedByLastName, item?.requestedBySecondLastName);

            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={0} classes={"first-column"}>
                        <div className={"ml-1"}>
                            <p className={"mb-1"}>{visitorFullName}</p>
                            <CustomChip legend={t(status[STATUS_MODEL.ACTIVE])}
                                borderColor={statusBorderColor[STATUS_MODEL.ACTIVE]}
                                fontColor={statusFontColor[STATUS_MODEL.ACTIVE]}
                                background={statusColor[STATUS_MODEL.ACTIVE]}
                                variant={'large'}
                            />
                        </div>
                    </CustomTd>

                    <CustomTd tableId={tableId}>
                        {item?.requestedByEmail || ''}
                    </CustomTd>

                    <CustomTd tableId={tableId}>
                        {item?.requestedByPhoneNumber || ''}
                    </CustomTd>

                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getDateFormat(item?.createdAt, false)}
                        </div>
                        <div className={"d-flex"}>
                            <IconClockTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getTimeFormat(item?.createdAt)}
                        </div>
                    </CustomTd>

                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            image={IconClip}
                            containerClass={`d-flex align-items-center ${assetsId?.length > 0 ?
                                'text-decoration-underline font-color-secondary-700 icon-color-secondary-700' :
                                'font-color-shades-500 icon-color-shades-500'}`}
                            text={`${assetsId?.length > 0 ? assetsId.length + ' ' + t('files') : EMPTY_VALUES.DEFAULT}`}
                            click={(e, image) => {
                                handleZipDownload(assetsId, visitorFullName);
                            }}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[requestStatus])}
                            borderColor={statusBorderColor[requestStatus]}
                            fontColor={statusFontColor[requestStatus]}
                            background={statusColor[requestStatus]}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content
        };
    };

    const handleUpdateStatus = (status, description, id) => {
        dispatch(ApplyDecisionRequest({ id: id, reason: description, statusId: status }))
            .then(({ payload: { data: { code, success } } }) => {
                if (success) {
                    setModified(true);
                    if(status == STATUS_MODEL.APPROVED){
                        toast.success(t('has_been_approved_successfully'));
                        navigate(routes.visitorInvitation.create,
                            { state: {
                                requestAccessId: id,
                                backUrl: routes.visitor.list,
                                currentTab: activeStep,
                                currentSubView: VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS
                            }});
                        return;
                    }
                    toast.success(t('has_been_denied_successfully'));
                } else {
                    errorMsg(code)
                }
            })
    }


    const handleZipDownload = (ids, name) => {
        if (!ids || ids?.length == 0) {
            toast.warn(t('no_files_registered'));
            return;
        }
        const nameZip = formatName(name);
        dispatch(ZipDownload(ids)).then(({ payload: { data, code } }) => {
            if (data) {
                DownloadDataZip(data, nameZip)
            } else {
                errorMsg(code)
            }
        })
    }

    const handleCancelModal = (status) => {
        setShowModal(false);
        setItemSelected(null);
        setModal(null);
    }

    const handleCancelDetails = () => {
        setDetailsModal(false);
        setModal(getModalModel(status[STATUS_MODEL.DENIED], itemSelected.id));
        setShowModal(true);
    }

    const handleConfirmDetails = () => {
        setDetailsModal(false);
        setModal(getModalModel(status[STATUS_MODEL.APPROVED], itemSelected.id));
        setShowModal(true);
    }

    const handleCloseDetails = () => {
        setDetailsModal(false);
        setItemSelected(null);
    }


    const getModalModel = (type, id) => {
        const modelStatus = {
            APPROVED: {
                title: "approve_request",
                subtitle: "are_you_sure_to_proceed",
                resume: "you_can_leave_a_optional_comment",
                statusRequest: STATUS_MODEL.APPROVED,
                handleConfirm: (description) => handleUpdateStatus(STATUS_MODEL.APPROVED, description, id),
                handleCancel: () => handleCancelModal(STATUS_MODEL.APPROVED)
            },
            DENIED: {
                title: "reject_request",
                subtitle: "are_you_sure_to_proceed",
                resume: "please_provide_a_reason",
                statusRequest: STATUS_MODEL.DENIED,
                handleConfirm: (description) => handleUpdateStatus(STATUS_MODEL.DENIED, description, id),
                handleCancel: () => handleCancelModal(STATUS_MODEL.DENIED)
            }
        };

        return modelStatus[type];
    };

    const getActionsButtons = (item, index) => {
        return <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
            >

                <DropDownMenuItem
                    id={"btn_arta_details_" + item?.id}
                    index={index}
                    handleClose={handleClose}
                    name={t('details')}
                    click={() => {
                        setItemSelected(item);
                        setDetailsModal(true);
                    }}
                    icon={<DetailsIconsOptions />}
                />
                {!isGuardTable &&
                item.statusId === STATUS_MODEL.APPROVED &&
                item.userInvitationId === null &&
                (DEV || permission.includes(permissionObj?.WEB_REQUEST_ACCESS_MANAGE)) &&
                [
                    <DropDownMenuItem
                        id={"btn_art_create_invitation_" + item?.id}
                        index={index}
                        handleClose={handleClose}
                        name={t('create_invitation')}
                        click={() => {
                            navigate(routes.visitorInvitation.create,
                                { state: {
                                        requestAccessId: item?.id,
                                        backUrl: routes.visitor.list,
                                        currentTab: activeStep,
                                        currentSubView: VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS
                                    }});
                        }}
                        icon={<EmailOpenPlusOptions />}
                    />,
                ]
                }

                {!isGuardTable &&
                    item.statusId === STATUS_MODEL.REQUESTED &&
                    (DEV || permission.includes(permissionObj?.WEB_REQUEST_ACCESS_MANAGE)) &&
                    [
                        <DropDownMenuItem
                            id={"btn_arta_approve_" + item?.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('approve')}
                            click={() => {
                                setModal(getModalModel(status[STATUS_MODEL.APPROVED], item.id))
                                setShowModal(true);
                            }}
                            icon={<CheckIconsOptions />}
                        />,
                        <DropDownMenuItem
                            id={"btn_arta_reject_" + item?.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('reject')}
                            fontColor={"font-color-error-600"}
                            iconColor={"icon-color-error-code-600"}
                            click={() => {
                                setModal(getModalModel(status[STATUS_MODEL.DENIED], item.id))
                                setShowModal(true)
                            }}
                            icon={<IconRejectedByVisitorCard className="icon-color-error-code-600" />}
                        />
                    ]
                }
            </DropDownMenuProfile>
        </>;
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: optionTable,
            key: searchElement,
            viewType: VIEW_TYPE.LIST.viewType,
            userId: isGuardTable ? null : userId
        });

        dispatch(endpoint({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success === true) {
                setResults(data);
                elementRef.current = true;
            }
        });
    };

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { thead, tbody, t, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        openMenu, handleMenuToggle, handleClose } = TableFunction({
            getTbody: getTbody,
            getThead: getThead,
            data: results,
            labelRowsPerPage: 'active_requests_per_page',
            hasContainer: true,
            fixedPagination: false,
            setIsAllChecked,
            searchElement,//New
            getData,//New
            modified,//New
            setModified,//New
        });

    return {
        t,
        DEV,
        permission,
        navigate,
        setResults,
        page,
        rowsPerPage,
        setSimpleSearch,
        tableId,
        searchId,
        isAllChecked,
        thead,
        tbody,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        showModal,
        setShowModal,
        modal,
        detailsModal,
        itemSelected,
        handleCancelDetails,
        handleConfirmDetails,
        handleCloseDetails,
        userId,
        setDetailsModal
    };
};

export default ActiveRequestsTableApp
